import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const PURCHASES = [{
  name: 'María González',
  city: 'Buenos Aires'
}, {
  name: 'Claudia Fernández',
  city: 'Córdoba'
}, {
  name: 'Silvia Romero',
  city: 'Rosario'
}, {
  name: 'Ana Martínez',
  city: 'Mendoza'
}, {
  name: 'Patricia López',
  city: 'La Plata'
}, {
  name: 'Graciela Torres',
  city: 'Tucumán'
}, {
  name: 'Mónica Díaz',
  city: 'Mar del Plata'
}, {
  name: 'Verónica Ruiz',
  city: 'Salta'
}, {
  name: 'Carolina Pérez',
  city: 'Santa Fe'
}, {
  name: 'Laura Sánchez',
  city: 'San Juan'
}, {
  name: 'Marcela Herrera',
  city: 'Neuquén'
}, {
  name: 'Sandra Morales',
  city: 'Bahía Blanca'
}, {
  name: 'Daniela Castro',
  city: 'Corrientes'
}, {
  name: 'Alejandra Vargas',
  city: 'Resistencia'
}, {
  name: 'Natalia Gutiérrez',
  city: 'Posadas'
}];
function getRandomPurchase(exclude?: number): {
  purchase: (typeof PURCHASES)[0];
  index: number;
} {
  let idx: number;
  do {
    idx = Math.floor(Math.random() * PURCHASES.length);
  } while (idx === exclude);
  return {
    purchase: PURCHASES[idx],
    index: idx
  };
}
function getTimeAgo(): string {
  const options = ['hace 2 minutos', 'hace 5 minutos', 'hace 8 minutos', 'hace 12 minutos', 'hace 3 minutos'];
  return options[Math.floor(Math.random() * options.length)];
}
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [exiting, setExiting] = useState(false);
  const [currentIdx, setCurrentIdx] = useState<number>(-1);
  const [currentPurchase, setCurrentPurchase] = useState<(typeof PURCHASES)[0] | null>(null);
  const [timeAgo, setTimeAgo] = useState('');
  const showNext = (excludeIdx: number) => {
    const {
      purchase,
      index
    } = getRandomPurchase(excludeIdx);
    setCurrentPurchase(purchase);
    setCurrentIdx(index);
    setTimeAgo(getTimeAgo());
    setExiting(false);
    setVisible(true);
  };
  const dismiss = () => {
    setExiting(true);
    setTimeout(() => {
      setVisible(false);
      setExiting(false);
    }, 400);
  };
  useEffect(() => {
    // First popup after 4 seconds
    const firstTimer = setTimeout(() => {
      showNext(-1);
    }, 4000);
    return () => clearTimeout(firstTimer);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // Auto-dismiss after 5 seconds
    const dismissTimer = setTimeout(() => {
      dismiss();
    }, 5000);
    return () => clearTimeout(dismissTimer);
  }, [visible, currentIdx]);
  useEffect(() => {
    if (visible || exiting) return;
    // Show next popup after 10-15 seconds
    const delay = 10000 + Math.random() * 5000;
    const nextTimer = setTimeout(() => {
      showNext(currentIdx);
    }, delay);
    return () => clearTimeout(nextTimer);
  }, [visible, exiting]);
  if (!visible && !exiting) return null;
  return <div className={`fixed bottom-4 left-4 z-50 max-w-xs w-full ${exiting ? 'popup-exit' : 'popup-enter'}`} role="alert" aria-live="polite" data-id="element-18">
      <div className="bg-white rounded-xl shadow-2xl border border-gray-100 p-4 flex items-start gap-3" data-id="element-19">
        <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
        backgroundColor: 'var(--color-green-dark)'
      }} data-id="element-20">
          <ShoppingBagIcon className="w-5 h-5 text-white" data-id="element-21" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-22">
          <p className="text-sm font-semibold text-gray-900 leading-tight" data-id="element-23">
            {currentPurchase?.name}
          </p>
          <p className="text-xs text-gray-600 mt-0.5" data-id="element-24">
            de <span className="font-medium" data-id="element-25">{currentPurchase?.city}</span>{' '}
            acaba de comprar este libro digital
          </p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-26">{timeAgo}</p>
        </div>
        <button onClick={dismiss} className="text-gray-400 hover:text-gray-600 flex-shrink-0 transition-colors" aria-label="Cerrar notificación" data-id="element-27">
          <XIcon className="w-4 h-4" data-id="element-28" />
        </button>
      </div>
    </div>;
}